import Vue from 'vue';
import store from './store';
import ossUpload from '@/assets/script/lib/oss/upload'
import {cookie} from '@deanwu/vue-component-library'

let app = new Vue();

// Alpha [开发环境]; Beta [测试环境]; Preview [预发布环境]; Online [正式环境]
const RE = "Online";
const SAAS = false;
const SERVER_ADDR = (re => {
	switch(re) {
		case 'Alpha':
			return '/develop';
		case 'Beta':
			return '/test';
		case 'Preview':
			return '/pre';
		case 'Online':
			return '/api';
	}
})(RE);

var loginTimeoutConfirm = false;

export {SAAS}

export default {
	request: {
		md5Key: 'V52kPpLS6msz7y3NfZUZ9OKFYeoGysMOeMSPdcObi6onvgmgKKEP5gk3s2omhDDOV3T6SYitc5bKUEzZECnEuN61YvObbu2SD7InNlnWeB8j7M195swDhAYjEnLAI71M',
		enKey: 'b2bc2dcff9074d84',
		deKey: '83fe4c23467507cd',
		log: RE != 'Online' || !!cookie.get('debug'),
		baseUrl: SERVER_ADDR,
		dataFormatter(data) {
			data.session = store.state.session;
			return data;
		},
		response(data, requestQueue) {
			if (data.code == 405 || data.code == 403) {
				if (!loginTimeoutConfirm) {
					loginTimeoutConfirm = true;
					app.$confirm({
						message: '登录状态已失效，请重新登录',
						buttonName: '重新登录',
						cancelButton: false,
						resolve: () => {
							$app.$store.commit('setSession', '');
							$app.navigateTo('/login');
							loginTimeoutConfirm = false;
						}
					});
				}
				for (let i in requestQueue) {
					requestQueue[i].abort();
				}
				return false;
			}
		}
	},
	
	uploadFile(files, success) {
		ossUpload(files, {
			success
		});
	},
	
	theme: {
		main: SAAS ? '#009EE7' : '#0060EF',
		mainHover: SAAS ? '#00AFF9' : '#005AE1',
		lesser: '',
		lesserHover: '',
		adorn: ''
	},
	
	style: {
		cutLine: '#eee',
		
		buttonSize: {
			search: {
				'height': '28px',
				'border-radius': '2px',
				'padding': '0 10px',
				'font-size': '12px'
			}
		},
		
		table: {
			showColBorder: false,  // 是否显示列的边框
			headBorder: false,  // 表头边框色
			headBackground: '#F2F4F7',  // 表头背景色
			rowBorder: '#eee',  // 行边框色
			rowBackground: '#fff',  // 行背景色
			rowHoverBackground: '#FAFCFE',  // 行移入背景色
			rowHlBackground: '#FAFCFE'  // 行选中背景色
		}
	},
	
	empty: {
		normal: {
			icon: require('@/assets/image/empty.png'),
			message: '暂无相关信息'
		},
	},
	
	data: {
		authority() {
			return store.state.authList;
		},
		
		options: {
			'PRODUCT_CLASSIFY'(keyword, resolve) {
				app.request({
					url: '/product_type/options',
					success: data => {
						let cache = {}, options = [];
						data.forEach(item => {
							if (!cache[item.id]) {
								cache[item.id] = {
									name: '',
									value: 0,
									children: []
								}
							}
							cache[item.id].name = item.option;
							cache[item.id].value = item.id;
							
							if (item.pid == 0) {
								options.push(cache[item.id]);
							} else {
								if (!cache[item.pid]) {
									cache[item.pid] = {
										name: '',
										value: 0,
										children: []
									}
								}
								cache[item.pid].children.push(cache[item.id]);
							}
						});
						resolve(options);
					}
				})
			},
			
			'PRODUCT_GROUP'(keyword, resolve) {
				app.request({
					url: '/product_group/all_list',
					success: data => {
						!function loop(list) {
							if (list && list.length) {
								list.forEach(item => {
									item.name = item.group_name;
									item.value = item.id;
									item.children = item.chlidren;
									loop(item.children);
								});
							}
						}(data);
						resolve(data);
					}
				})
			},
			
			'BRAND_LIST'(keyword, resolve) {
				app.request({
					url: '/product_brand/options',
					success: data => {
						resolve(Array.from(data, item => {
							return {
								name: item.brand_name,
								value: item.brand_id
							}
						}));
					}
				})
			}
		},
		
		region(type, pid) {
			return new Promise(resolve => {
				app.request({
					url: '/address_library/region',
					data: {
						parent_id: pid
					},
					success: data => {
						resolve(Array.from(data, item => {
							return {
								name: item.name,
								value: item.id
							}
						}))
					}
				});
			})
		}
	}
}